module.exports = __webpack_public_path__ + "ee354c4f3d0a20efbae4ccf8891f9b09.png";